module.exports = __webpack_public_path__ + "assets/img/not_data_tips-d51b3d2e.png";